import {
    NativeInvoiceAdjustmentSetting,
    NativeInvoiceAdjustmentSettings,
} from "@common/schemas/domains/invoice/native-invoice-adjustment-settings.schema";

export interface NativeInvoiceAdjustmentCoding {
    accountId: string | null;
    receivablesAccountId: string | null;
    classIds: string[];
}

export interface NativeInvoiceAdjustmentSettingsForm {
    tax: NativeInvoiceAdjustmentCoding;
    discount: NativeInvoiceAdjustmentCoding;
    deposit: NativeInvoiceAdjustmentCoding;
}

function emptyCoding(): NativeInvoiceAdjustmentCoding {
    return {
        accountId: null,
        receivablesAccountId: null,
        classIds: [],
    };
}

export function emptyNativeInvoiceAdjustmentSettings(): NativeInvoiceAdjustmentSettingsForm {
    return {
        tax: emptyCoding(),
        discount: emptyCoding(),
        deposit: emptyCoding(),
    };
}

function codingFromSetting(
    setting: NativeInvoiceAdjustmentSetting | null | undefined,
): NativeInvoiceAdjustmentCoding {
    if (!setting) {
        return emptyCoding();
    }
    return {
        accountId: setting.accountId,
        receivablesAccountId: setting.receivablesAccountId,
        classIds: setting.classIds,
    };
}

export function nativeInvoiceAdjustmentSettingsFromResponse(
    settings: NativeInvoiceAdjustmentSettings | null | undefined,
): NativeInvoiceAdjustmentSettingsForm {
    return {
        tax: codingFromSetting(settings?.tax),
        discount: codingFromSetting(settings?.discount),
        deposit: codingFromSetting(settings?.deposit),
    };
}
